<div class="flex flex-col max-h-[80vh] gap-6 p-6">
    <!-- Header (fixed) -->
    <section
      id="location-dialog-header"
      class="flex justify-between items-center pb-2 shrink-0 neptune-border-b-1 border-sky-blue"
    >
      <span class="text-2xl">Units: {{ data.units }}</span>

      <div (click)="closeDialog()" class="cursor-pointer">
        <img
          alt="close"
          src="assets/shared-icons/neptune-icon-blue-close.svg"
          class="w-6 h-6"
        />
      </div>
    </section>

    <!-- Scrollable table section -->
    <section id="location-dialog-table" class="flex-1 overflow-y-auto">
      <table
        class="table-fixed box-border min-w-[480px] w-full border-collapse"
      >
        <colgroup>
          <col class="w-[25%]" />
          <col class="w-[25%]" />
          <col class="w-[50%]" />
        </colgroup>

        <thead id="location-dialog-table-header" class="bg-neptune-muted">
          <tr>
            <th
              class="text-left p-4 neptune-border-b-2 border-neptune-border-subtle"
            >
              Account Number
            </th>
            <th
              class="text-left p-4 neptune-border-b-2 border-neptune-border-subtle"
            >
              Account Name
            </th>
            <th
              class="text-left p-4 neptune-border-b-2 border-neptune-border-subtle"
            >
              Address
            </th>
          </tr>
        </thead>

        <tbody id="location-dialog-table-body">
          <tr *ngFor="let rowData of dataSource.data; let i = index">
            <td class="account-number p-4 max-w-0">
              <span class="block truncate" [title]="rowData.accountNumber">{{
                rowData.accountNumber
              }}</span>
            </td>

            <td class="account-name p-4 max-w-0">
              <span class="block truncate" [title]="rowData.accountName">{{
                rowData.accountName
              }}</span>
            </td>

            <td class="address p-4 max-w-0">
              <span class="block truncate" [title]="rowData.address">{{
                rowData.address
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- Footer (fixed) -->
    <section
      id="location-dialog-footer"
      class="flex justify-end gap-4 pt-4 shrink-0 neptune-border-t-2 border-neptune-border-subtle"
    >
      <button
        (click)="downloadAsExcel()"
        id="location-dialog-export-excel"
        class="neptune-button-blue flex items-center gap-2"
      >
        <img
          alt="download"
          src="assets/shared-icons/neptune-download-icon.svg"
          class="w-6 h-6"
        />
        Download Excel
      </button>

      <button
        (click)="closeDialog()"
        id="location-dialog-close"
        class="neptune-button-white"
      >
        Close
      </button>
    </section>
  </div>
